/**
 * PrintService — Barrel de ré-exports unifié pour l'impression VisionPOS.
 *
 * Phase 3c : ce fichier est désormais un barrel pur. Il ré-exporte tous les
 * symboles publics des sous-modules afin que les consommateurs existants
 * (usePrinter.ts, PrintingApi.ts, TicketPreview, Duplicata, TogoTickets,
 * KitchenPrinterPickerDialog) n'aient pas à changer leurs imports.
 *
 * Architecture sous-jacente :
 *   escpos-types.ts       — types partagés (TicketData, PrinterConfig, ZReportData…)
 *   escpos-formatter.ts   — builders ESC/POS purs (sans état, sans dépendances ext.)
 *   printer-adapters.ts   — transport physique (BT, AIDL, Cloud, Network)
 *   printer-adapters-z.ts — transport Z/X (extrait Phase 3c — split > 500 LOC)
 *   printer-router.ts     — résolution imprimante + routing
 *   print-orchestrator.ts — chargement DB + orchestration (buildDemo, printSale…)
 *   expense-printing.ts   — note de frais (extrait Phase 3c — split > 500 LOC)
 *   printLog.ts           — shim logging (délègue à src/api/printing/logging.ts)
 *
 * Invariants :
 *   4.A.16 : mentions NF525 dans escpos-formatter.ts et printer-adapters.ts — ce
 *            barrel ne touche pas le formatage.
 *   4.B.2  : pas d'import supabase dans ce fichier (délégué aux sous-modules).
 *   4.B.5  : Strangler Fig — le barrel coexiste avec les nouveaux modules sans
 *            réécriture big bang.
 */

// ── Types ────────────────────────────────────────────────────────────────────

export type { PrinterConfig, TicketData } from './escpos-types';
export type { KitchenData, ZReportData } from './escpos-formatter';

// ── Résolution + routing ─────────────────────────────────────────────────────

export {
  findPrinter,
  listTenantPrinters,
  loadTicketConfig,
  printReceipt,
  printZReport,
  printKitchen,
  openDrawer,
  openDrawerForRegister,
} from './printer-router';

// ── Orchestration haut niveau ────────────────────────────────────────────────

export {
  buildDemoTicketData,
  testPrint,
  printSaleReceipt,
  printExpenseFromSale,
} from './print-orchestrator';

// ── Bons de commande provisoires (NON fiscaux) ───────────────────────────────

export {
  printCustomerDraft,
  printKitchenDraft,
  normalizeDraftItems,
  computeDraftTotals,
} from './draft-printing';
export type { DraftOrderPrintInput, DraftPrintItem, DraftTotals } from './draft-printing';
